import { useCallback, useMemo } from "react";
import type { StudentQuestionAnswer, StudentTestExercise } from "p6m-p6u";

interface UseExerciseAnswersParams {
    exercise: StudentTestExercise;
    studentAnswer: StudentQuestionAnswer;
    onAnswerUpdate: (updatedAnswer: StudentQuestionAnswer, exerciseId: string) => void;
}

const useExerciseAnswers = (params: UseExerciseAnswersParams) => {
    const exerciseId = params.exercise.id;
    const studentAnswer = params.studentAnswer;
    const onAnswerUpdate = params.onAnswerUpdate;

    const answers = useMemo(() => studentAnswer.studentAnswers ?? [], [studentAnswer.studentAnswers]);

    const updateItemAtPosition = useCallback(
        (index: number, value: string) => {
            if (!exerciseId) return;
            const newAnswers = [...answers];
            newAnswers[index] = { ...newAnswers[index], studentAnswer: value };
            onAnswerUpdate({ ...studentAnswer, studentAnswers: newAnswers }, exerciseId);
        },
        [exerciseId, answers, studentAnswer, onAnswerUpdate]
    );

    return { exerciseId, answers, updateItemAtPosition };
};

export default useExerciseAnswers;
